import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { changeLogin } from '../actions/login';
import { reset } from '../actions/authentication';
import { changeTab } from '../actions/tabs';
import { setState } from '../actions/state';
import { changeView } from '../actions/view';
import { loadMROAuth } from '../../browser/utils/loadMROAuth';
import { initMROAuth } from './initMROAuth';
import { professionalUserChange } from '../actions/registration';
import { changeSource } from '../actions/source';
export var AuthenticationContext = /*#__PURE__*/function () {
  function AuthenticationContext(store, emitter) {
    _classCallCheck(this, AuthenticationContext);
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "emitter", void 0);
    this.store = store;
    this.emitter = emitter;
  }
  _createClass(AuthenticationContext, [{
    key: "state",
    get: function get() {
      return this.store.getState();
    },
    set: function set(state) {
      this.store.dispatch(setState(state));
    }
  }, {
    key: "setTab",
    value: function setTab(tab) {
      this.store.dispatch(changeTab(tab));
    }
  }, {
    key: "setView",
    value: function setView(view, data) {
      this.store.dispatch(changeView(view, data));
    }
  }, {
    key: "setSource",
    value: function setSource(source) {
      this.store.dispatch(changeSource(source));
    }
  }, {
    key: "resetAuthentication",
    value: function resetAuthentication() {
      this.store.dispatch(reset());
    }
  }, {
    key: "setAuthenticationLogin",
    value: function setAuthenticationLogin(login) {
      this.store.dispatch(changeLogin(login));
    }
  }, {
    key: "setRegistrationParams",
    value: function setRegistrationParams(params) {
      this.store.dispatch(professionalUserChange(params.isProfessionalUser));
    }
  }, {
    key: "showMROAuthOneTap",
    value: function showMROAuthOneTap() {
      var _this = this;
      return loadMROAuth().then(function (MR) {
        MR.logout();
        initMROAuth({
          authClient: MR,
          store: _this.store,
          eventEmitter: _this.emitter
        });
      });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "on",
    value: function on(type, handler) {
      this.emitter.addListener(type, handler);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "off",
    value: function off(type, handler) {
      this.emitter.removeListener(type, handler);
    }
  }]);
  return AuthenticationContext;
}();